// const API_URL = location.href.split("#")[0];
const API_URL = "https://maintenanceportal.datavtech.com/";
export default API_URL;
